import styled from 'styled-components'

// last child gets a bit extra margin due to the above body overflow scroll bar width
const Group = styled.div<GroupProps>`
  display: flex;
  align-content: ${({ childPosition }) => childPosition};
  &:first-child {
    margin-left: 40px;
    & > *:not(:last-child) {
      margin-right: 12px;
    }
  }
  &:last-child {
    margin-right: 60px;
    & > * {
      margin-left: 12px;
    }
  }
  @media(max-width: 767px) {
    &:first-child {
      margin-top: 4px;
      margin-right: auto;
      margin-bottom: 4px;
      margin-left: auto;
      & > *:not(:last-child) {
        margin-right: 4px;
        margin-left: 4px;
      }
    }
    &:last-child {
      margin-top: 4px;
      margin-right: auto;
      margin-bottom: 4px;
      margin-left: auto;
      & > * {
        margin-right: 4px;
        margin-left: 4px;
      }
    }
  }
`

export default Group

export interface GroupProps {
  childPosition: 'flex-start' | 'flex-end'
}
